// extracted by mini-css-extract-plugin
module.exports = {"inline-param":"_93444fe79c--inline-param--32bX-","inline-label":"_93444fe79c--inline-label--2EC4v"};